import { AdminComponent } from '~/components/admin-component/admin-component';

export const FundTypes = () => (
  <AdminComponent
    componentName="FundTypes"
    title="Fund Types"
  />
);
